// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"ebf33278","291":"ebf33278","314":"ebf33278","341":"dd8f257a","922":"ebf33278","964":"ebf33278"}[chunkId] + ".chunk.css";
};